import React from 'react'
import Attachment from "../../../../../model2/attachment/attachment"

type Props = {
    attachment  : Attachment
    size?       : number
}

export default function AttachmentThumbnail(props: Props) {

    const {attachment}    = props
    const thumbnailSize = _.get(props,'size', 160)


    const thumbnailSource = attachment.thumbnailUrl(thumbnailSize)

    const style={
        backgroundImage: `url("${thumbnailSource}")`
    }

    return (
        <div className="thumbnail" style={style} />
    );
}
